var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiometricIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#43BC9B;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.7,221.3v128c0,39.9,21.5,77,56,97c7.6,4.4,10.3,14.2,5.8,21.9c-3,5.1-8.3,8-13.9,8c-2.7,0-5.5-0.7-8-2.1 c-44.4-25.7-72-73.5-72-124.7v-128c0-8.8,7.2-16,16-16S130.7,212.5,130.7,221.3L130.7,221.3z M66.7,297.5v-70.3 C66.7,142.6,130.1,72.2,211,67c30.9-1.9,61.2,5.1,87.7,20.3c7.6,4.5,17.4,1.8,21.9-5.8c4.4-7.6,1.8-17.4-5.8-21.9 c-31.9-18.5-68.6-26.9-105.7-24.6c-97.7,6.3-174.3,90.7-174.3,192.1v70.3c0,8.8,7.2,16,16,16S66.7,306.3,66.7,297.5z M328,317.3 c0,29.5,23.9,53.3,53.3,53.3s53.3-23.9,53.3-53.3c0-29.5-23.9-53.3-53.3-53.3S328,287.9,328,317.3z M434.7,413.3H328 c-23.6,0-42.7,19.1-42.7,42.7v21.3h192V456C477.3,432.4,458.2,413.3,434.7,413.3z M276.5,388.7c8.3-6.3,17.7-11.4,28.1-14.3 c-1.9-2.5-3.4-5.3-5.1-8c-11.8-8.8-19.5-22.6-19.5-38.4V223.6c0-29.8-21-55.6-48.9-60.2c-17.2-2.8-34.6,2-47.7,13.2 c-13.1,11.2-20.7,27.5-20.7,44.7v85.3c0,61.3,30.3,118.1,80,152.8V456c0-11.3,2.5-22,6.5-31.9c-34-29.1-54.5-71.7-54.5-117.4v-85.3 c0-7.8,3.4-15.2,9.4-20.3c6-5.2,13.8-7.2,21.9-6c12.6,2,22.1,14.3,22.1,28.6V328C248,352.4,259.2,374,276.5,388.7L276.5,388.7z  M233.3,99.2c-43.2-4.2-84.2,14-110.1,48.5c-5.3,7.1-3.9,17.1,3.2,22.4c7.1,5.3,17.1,3.9,22.4-3.2c19.1-25.5,49.6-38.8,81.5-35.8 c45.8,4.4,81.7,46,81.7,94.8v25.4c9-9.5,19.8-17.2,32-22.4v-3C344,160.8,295.4,105.1,233.3,99.2L233.3,99.2z M381.3,221.3 c9.3,0,18.1,1.8,26.7,4.2v-4.2c0-32.8-8.6-65.1-25-93.3c-4.4-7.6-14.2-10.3-21.9-5.8c-7.6,4.4-10.3,14.2-5.8,21.9 c13.5,23.4,20.7,50.1,20.7,77.3v0.5C377.8,221.8,379.5,221.3,381.3,221.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiometricIcon);
export default __webpack_public_path__ + "static/media/biometric-icon.3f5894bd7dacd51f9163946561c3f063.svg";
export { ForwardRef as ReactComponent };